import React from 'react';
import { IProps as ITwoColumnLayoutProps } from './TwoColumnLayout.interface';
import { TwoColumnLayout } from './TwoColumnLayout.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface ITwoColumnLayoutInputProps {
    leftMenu?: any;
    [key: string]: any; // For BlockWrapper props
}

const mapInputToProps = (input: ITwoColumnLayoutInputProps): ITwoColumnLayoutProps => {
    const { leftMenu, mainComponents, ...rest } = input;
    return {
        ...input,
        left: input.leftMenu ? [{ "name": "SecondaryNavigation", props: input.leftMenu }] : undefined,
        right: input.mainComponents || undefined,
        layout: 'right',

    };
};

const TwoColumnLayoutTranslation: React.FC<ITwoColumnLayoutInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={TwoColumnLayout}
        mapProps={mapInputToProps}
    />
);

export default TwoColumnLayoutTranslation;
